module.exports = __webpack_public_path__ + "static/img/sup_logo_2.78afc88d.png";